import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function parallax() {
  const parallaxElements = document.querySelectorAll('[data-parallax]');
  if (!parallaxElements.length) return;


  parallaxElements.forEach((el, index) => {
    // Set ascending z-index so later sections render on top of earlier pinned ones
    gsap.set(el, { position: 'relative', zIndex: index + 1 });

    // Ensure all siblings between this and the next [data-parallax] element
    // (e.g. <span class="decor">) also sit on top of the pinned element
    let sibling = el.nextElementSibling;
    while (sibling && !sibling.hasAttribute('data-parallax')) {
      gsap.set(sibling, { position: 'relative', zIndex: index + 2 });
      sibling = sibling.nextElementSibling;
    }

    const isTallerThanViewport = el.offsetHeight > window.innerHeight;
    const extraScroll = 200;

    // Add bottom padding to create real scroll distance before the next section arrives
    gsap.set(el, { paddingBottom: `+=${extraScroll}` });

    ScrollTrigger.create({
      trigger: el,
      // Short elements: pin when top hits top of viewport
      // Tall elements: pin when bottom hits bottom of viewport
      start: isTallerThanViewport ? 'bottom bottom' : 'top top',
      // Keep pinned for the element's full height so the next section
      // can scroll over and fully cover it
      end: () => `+=${el.offsetHeight}`,
      pin: true,
      pinSpacing: false,
    });
  });
}
